import { Pipe, PipeTransform } from '@angular/core';
import { cssValue } from '@helpers';

/* Si el valor indicado es una variable css, lo devuelve formateado como tal */

@Pipe({
  name: 'cssValue',
  standalone: true,
})
export class CSSValuePipe implements PipeTransform {
  transform(value: string | number | undefined): string | undefined {
    return cssValue(value);
  }
}
